import { Component, Object3D, Property } from '@wonderlandengine/api';
import { property } from '@wonderlandengine/api/decorators.js';
import { GlobalEvents } from './global-events.js';

/**
 * Main game objectives the player needs to complete
 */
export enum ObjectiveType {
    None = 0,
    TalkToDolly,
    FindMusicBoxKey,
    FindCup,
    ReturnToDolly,
}

export class Objective {
    @property.enum(Object.keys(ObjectiveType).filter((e) => isNaN(Number(e))))
    objectiveType: ObjectiveType = ObjectiveType.None;

    @property.string('')
    description: string = '';

    @property.array(
        Property.enum(
            Object.keys(ObjectiveType).filter((e) => isNaN(Number(e)))
        )
    )
    requirements: ObjectiveType[] = [];

    completed: boolean = false;
}

export class GameManager extends Component {
    static TypeName = 'game-manager';

    @property.array(Property.record(Objective))
    objectives: Objective[] = [];

    @property.object({ required: true })
    startLocation!: Object3D;

    // Singleton
    private static _instance: GameManager;
    static get instance(): GameManager {
        return GameManager._instance;
    }

    init() {
        if (GameManager._instance) {
            console.error(
                'There can only be one instance of GameManager Component'
            );
        }
        GameManager._instance = this;
    }
    start(): void {}

    completeObjective(objective: ObjectiveType) {
        if (objective === ObjectiveType.None) {
            return;
        }

        const obj = this.objectives.find((o) => o.objectiveType === objective);

        if (obj) {
            // Check if all requirements are met
            if (
                obj.requirements.every((req) =>
                    this.objectives.find(
                        (o) =>
                            (o.objectiveType === req && o.completed) ||
                            req === ObjectiveType.None
                    )
                )
            ) {
                obj.completed = true;
                GlobalEvents.instance.objectiveCompleted.dispatch(objective);
                console.log(`Objective completed: ${ObjectiveType[objective]}`);
            }
        }
    }
}
